var _path, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0003 11.6666C15.4087 11.6666 11.667 15.4083 11.667 20C11.667 24.5916 15.4087 28.3333 20.0003 28.3333C24.592 28.3333 28.3337 24.5916 28.3337 20C28.3337 15.4083 24.592 11.6666 20.0003 11.6666ZM23.9837 18.0833L19.2587 22.8083C19.142 22.925 18.9837 22.9916 18.817 22.9916C18.6503 22.9916 18.492 22.925 18.3753 22.8083L16.017 20.45C15.7753 20.2083 15.7753 19.8083 16.017 19.5666C16.2587 19.325 16.6587 19.325 16.9003 19.5666L18.817 21.4833L23.1003 17.2C23.342 16.9583 23.742 16.9583 23.9837 17.2C24.2253 17.4416 24.2253 17.8333 23.9837 18.0833Z",
    fill: "#0C78F1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 39.5,
    height: 39.5,
    rx: 9.75,
    stroke: "#0C78F1",
    strokeWidth: 0.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.18ee570471acf1ff171e8ff404807651.svg";
export { ForwardRef as ReactComponent };